import _ from 'lodash';
import { dictionary as routes } from './routes';
import { dictionary as models } from './models';
import dayjs from './dayjs';
import { dictionary as basics } from './basics';
import { dictionary as rules } from './rules';

const fullDictionary = {
	de: {
		$global: {
			boolean: {
				true: 'ja',
				false: 'nein',
			},
			secret: 'geheim',
			date: {
				short: 'DD.MM.YY',
				dayMonth: 'DD.MM.',
				normal: 'DD.MM.YYYY',
				normalDayString: 'DD.MM.YYYY, dddd',
				normalDayStringKWText: 'DD.MM.YYYY, dddd, [KW]WW',
				normalDayStringKW: 'DD.MM.YYYY | dddd | [KW]WW',
				KWdaylongInt: '[KW]WW | dddd | YYYY-MM-DD',
				normalKW: 'DD.MM.YYYY [|] [KW]WW',
				long: 'DD.MMM.YYYY',
				longInt: 'YYYY-MM-DD',
				longIntDayString: 'YYYY-MM-DD, dddd',
			},
			dateTerms: {
				calendarWeekShort: 'KW',
			},
			time: {
				short: 'HH:mm',
				normal: 'HH:mm',
				long: 'HH:mm',
			},
			dateTime: {
				short: 'DD.MM.YY HH:mm',
				normal: 'DD.MM.YYYY HH:mm',
				long: 'DD.MMM.YYYY HH:mm',
				KWdaylongIntTime: '[KW]WW | dddd | YYYY-MM-DD | HH:mm',
			},
			days: {
				0: 'Sonntag',
				1: 'Montag',
				2: 'Dienstag',
				3: 'Mittwoch',
				4: 'Donnerstag',
				5: 'Freitag',
				6: 'Samstag',
			},
			dayShort: {
				0: 'So',
				1: 'Mo',
				2: 'Di',
				3: 'Mi',
				4: 'Do',
				5: 'Fr',
				6: 'Sa',
			},
			table: {
				itemsPerPage: 'Einträge pro Seite',
				of: 'von',
				all: 'Alle',
				sort: 'Sortieren',
			},
			actions: {
				save: 'Speichern',
				edit: 'Bearbeiten',
				archive: 'Archivieren',
				cancel: 'Abbrechen',
				close: 'Schließen',
				yes: 'Ja',
				no: 'Nein',
				myProfile: 'Mein Profil',
				settings: 'Einstellungen',
				logout: 'Logout',
				search: 'Suche',
				load: 'Laden',
				loadNow: '(lädt gerade...)',
			},
			messages: {
				saveQuestion: 'Wollen Sie den Eintrag speichern?',
				archiveQuestion: 'Wollen Sie den Eintrag archivieren?',
				noDataAvailable: 'Keine Daten vorhanden',
			},
			timestamps: {
				createdAt: 'Erstellt',
				updatedAt: 'Aktualisiert',
			},
		},
	},
	en: {
		$global: {
			boolean: {
				true: 'yes',
				false: 'no',
			},
			secret: 'secret',
			date: {
				short: 'MM/DD/YY',
				normal: 'YYYY-MM-DD',
				long: 'YYYY-MMM-DD',
			},
			time: {
				short: 'HH:mm',
				normal: 'HH:mm',
				long: 'HH:mm',
			},
			dateTime: {
				short: 'MM/DD/YY HH:mm',
				normal: 'YYYY-MM-DD HH:mm',
				long: 'YYYY-MMM-DD HH:mm',
			},
			table: {
				itemsPerPage: 'Rows per Page',
				of: 'of',
				all: 'All',
			},
			actions: {
				save: 'Save',
				edit: 'Edit',
				archive: 'Archive',
				cancel: 'Cancel',
				close: 'Close',
				yes: 'Yes',
				no: 'No',
				myProfile: 'My Profile',
				settings: 'Settings',
				logout: 'Logout',
			},
			messages: {
				saveQuestion: 'Are your sure you want to save the item?',
				archiveQuestion: 'Are your sure you want to archive the selected item?',
			},
		},
	},
};

addDictionary({ dictionary: routes, path: '$global.routes' });
addDictionary({ dictionary: models, path: '$global.models' });
addDictionary({ dictionary: dayjs, path: 'dayjs' });
addDictionary({ dictionary: basics, path: 'basics' });
addDictionary({ dictionary: rules, path: 'rules' });

function addDictionary({ dictionary, path }) {
	const additionalDictionary = {};
	for (const [language, messages] of Object.entries(dictionary)) {
		if (path) path = language + '.' + path;
		else path = language;
		_.set(additionalDictionary, path, messages);
	}
	_.merge(fullDictionary, additionalDictionary);
}

export default fullDictionary;
